import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewEscala = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'escala',
        name: 'Escala',
        component: ViewEscala,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
